const getFetchOptions = (method, body = null) => {
  const options = {
    method: method,
    body: body ? JSON.stringify(body) : null,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  return options;
};

export { getFetchOptions };